/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  Deletable,
  DeletableOptional,
  DeletableMetaI,
  DeletableTrackedI,
} from "./deletable";
import { DeletableTracked, DeletableMeta } from "./deletable";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ProductBase,
  ProductBaseOptional,
  ProductBaseMetaI,
  ProductBaseTrackedI,
} from "./product-base";
import { ProductBaseTracked, ProductBaseMeta } from "./product-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ProductRef,
  ProductRefOptional,
  ProductRefMetaI,
  ProductRefTrackedI,
} from "./product-ref";
import { ProductRefTracked, ProductRefMeta } from "./product-ref";

/**
 *
 * @export
 * @interface ProductFull
 */
export interface ProductFullOptional extends DeletableOptional {
  /**
   *
   * @type {boolean}
   * @memberof ProductFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ProductFull
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof ProductFull
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof ProductFull
   */
  tempID?: string;
  /**
   *
   * @type {string}
   * @memberof ProductFull
   */
  productName?: string;
  /**
   *
   * @type {string}
   * @memberof ProductFull
   */
  productDescription?: string;
  /**
   *
   * @type {boolean}
   * @memberof ProductFull
   */
  active?: boolean;
}

export interface ProductFull
  extends ProductFullOptional, Deletable, ProductBase, ProductRef {
  /**
   *
   * @type {boolean}
   * @memberof ProductFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ProductFull
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof ProductFull
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof ProductFull
   */
  tempID?: string;
  /**
   *
   * @type {string}
   * @memberof ProductFull
   */
  productName: string;
  /**
   *
   * @type {string}
   * @memberof ProductFull
   */
  productDescription: string;
  /**
   *
   * @type {boolean}
   * @memberof ProductFull
   */
  active: boolean;
}

export interface ProductFullTrackedI extends DeletableOptional {
  /**
   *
   * @type {boolean}
   * @memberof ProductFull
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ProductFull
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof ProductFull
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ProductFull
   */
  tempID?: string;
  tempIDIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ProductFull
   */
  productName?: string;
  productNameIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ProductFull
   */
  productDescription?: string;
  productDescriptionIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ProductFull
   */
  active?: boolean;
  activeIsSet: boolean;
}

transformDatesMap.set("ProductFull", function (model: ProductFull) {});

export type ProductFullMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  tempID: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  productName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  productDescription: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  active: PropertyMeta<MetaTypeBase<boolean>>;
}>;

export var ProductFullMeta: ProductFullMetaI = {} as ProductFullMetaI;
ProductFullMeta = typeMeta("ProductFull", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  tempID: propertyMeta("tempID", false, false, false, MetaTypesBase.string),
  productName: propertyMeta(
    "productName",
    false,
    true,
    false,
    MetaTypesBase.string,
  ),
  productDescription: propertyMeta(
    "productDescription",
    false,
    true,
    false,
    MetaTypesBase.string,
  ),
  active: propertyMeta("active", false, true, false, MetaTypesBase.boolean),
});

const metaI = ProductFullMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([DeletableMeta]);
  metaI.isDeleted.inheritedFrom = DeletableMeta.isDeleted;
  metaI.isNew.inheritedFrom = DeletableMeta.isNew;
  metaI.interfaces = metaI.interfaces.concat([ProductRefMeta]);
  metaI.assignId.inheritedFrom = ProductRefMeta.assignId;
  metaI.tempID.inheritedFrom = ProductRefMeta.tempID;
  metaI.interfaces = metaI.interfaces.concat([ProductBaseMeta]);
  metaI.productName.inheritedFrom = ProductBaseMeta.productName;
  metaI.productDescription.inheritedFrom = ProductBaseMeta.productDescription;
  metaI.active.inheritedFrom = ProductBaseMeta.active;
});

export class ProductFullTracked
  extends DeletableTracked
  implements ProductFullTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  tempID__I?: string = undefined;
  tempIDIsSet: boolean = false;
  set tempID(v: undefined | string) {
    if (v !== undefined) {
      this.tempID__I = v;
      this.tempIDIsSet = true;
    } else {
      this.tempID__I = v || undefined;
      this.tempIDIsSet = false;
    }
    this.changeTracker = true;
  }
  get tempID() {
    return this.tempID__I;
  }
  productName__I?: string = undefined;
  productNameIsSet: boolean = false;
  set productName(v: undefined | string) {
    if (v !== undefined) {
      this.productName__I = v;
      this.productNameIsSet = true;
    } else {
      this.productName__I = v || undefined;
      this.productNameIsSet = true;
    }
    this.changeTracker = true;
  }
  get productName() {
    return this.productName__I;
  }
  productDescription__I?: string = undefined;
  productDescriptionIsSet: boolean = false;
  set productDescription(v: undefined | string) {
    if (v !== undefined) {
      this.productDescription__I = v;
      this.productDescriptionIsSet = true;
    } else {
      this.productDescription__I = v || undefined;
      this.productDescriptionIsSet = true;
    }
    this.changeTracker = true;
  }
  get productDescription() {
    return this.productDescription__I;
  }
  active__I?: boolean = undefined;
  activeIsSet: boolean = false;
  set active(v: undefined | boolean) {
    if (v !== undefined) {
      this.active__I = v;
      this.activeIsSet = true;
    } else {
      this.active__I = v || undefined;
      this.activeIsSet = true;
    }
    this.changeTracker = true;
  }
  get active() {
    return this.active__I;
  }
  constructor(config?: ProductFullOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;
    if (this.tempIDIsSet == true && other?.tempIDIsSet == true)
      return this.tempID == other.tempID;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }
  }
  assignFrom(
    config: ProductFullOptional,
    options?: AssignOptions,
  ): ProductFullTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.tempID && this.tempIDApplyFilter(optionsRequired.filter)) {
      this.tempID = config.tempID;
      if (optionsRequired.unassign) this.tempIDIsSet = false;
      else this.tempIDIsSet = true;
    }
    if (
      config.productName &&
      this.productNameApplyFilter(optionsRequired.filter)
    ) {
      this.productName = config.productName;
      if (optionsRequired.unassign) this.productNameIsSet = false;
      else this.productNameIsSet = true;
    }
    if (
      config.productDescription &&
      this.productDescriptionApplyFilter(optionsRequired.filter)
    ) {
      this.productDescription = config.productDescription;
      if (optionsRequired.unassign) this.productDescriptionIsSet = false;
      else this.productDescriptionIsSet = true;
    }
    if (config.active && this.activeApplyFilter(optionsRequired.filter)) {
      this.active = config.active;
      if (optionsRequired.unassign) this.activeIsSet = false;
      else this.activeIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): ProductFullTrackedI {
    const cloned = {} as ProductFullTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.tempIDIsSetDeep() &&
      this.tempIDApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.tempIDIsSet = true;
      cloned.tempID = this.tempID;
    } else {
      //cloned.tempIDIsSet = false
    }
    if (
      this.productNameIsSetDeep() &&
      this.productNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.productNameIsSet = true;
      cloned.productName = this.productName;
    } else {
      //cloned.productNameIsSet = false
    }
    if (
      this.productDescriptionIsSetDeep() &&
      this.productDescriptionApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.productDescriptionIsSet = true;
      cloned.productDescription = this.productDescription;
    } else {
      //cloned.productDescriptionIsSet = false
    }
    if (
      this.activeIsSetDeep() &&
      this.activeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.activeIsSet = true;
      cloned.active = this.active;
    } else {
      //cloned.activeIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): ProductFullTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.tempIDApplyFilter(filter)) this.tempIDIsSet = false;

    if (!this.productNameApplyFilter(filter)) this.productNameIsSet = false;

    if (!this.productDescriptionApplyFilter(filter))
      this.productDescriptionIsSet = false;

    if (!this.activeApplyFilter(filter)) this.activeIsSet = false;

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ProductFullMeta.isDeleted,
      ProductFullMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(ProductFullMeta.isNew, ProductFullMeta, this.isNew, this);
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ProductFullMeta.assignId,
      ProductFullMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  tempIDApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(ProductFullMeta.tempID, ProductFullMeta, this.tempID, this);
  }
  tempIDIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.tempIDIsSet && this.tempIDApplyFilter(filter)) return true;

    return false;
  }
  productNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ProductFullMeta.productName,
      ProductFullMeta,
      this.productName,
      this,
    );
  }
  productNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.productNameIsSet && this.productNameApplyFilter(filter))
      return true;

    return false;
  }
  productDescriptionApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ProductFullMeta.productDescription,
      ProductFullMeta,
      this.productDescription,
      this,
    );
  }
  productDescriptionIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.productDescriptionIsSet &&
      this.productDescriptionApplyFilter(filter)
    )
      return true;

    return false;
  }
  activeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(ProductFullMeta.active, ProductFullMeta, this.active, this);
  }
  activeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.activeIsSet && this.activeApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.tempIDIsSetDeep(filter)) return true;
    if (this.productNameIsSetDeep(filter)) return true;
    if (this.productDescriptionIsSetDeep(filter)) return true;
    if (this.activeIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
